export const iconFontAwesomeAutomotiveOilCan = (
	<i className="fa-solid fa-oil-can"></i>
);
